export const ACCESS_TOKEN_KEY = '__access_token__'
export const REFRESH_TOKEN_KEY = '__refresh_token__'
export const SAAS_TOKEN_KEY = '__saas_token__'
export const APP_TOKEN_KEY = '__app_token_'
export const DEVICE_TOKEN_KEY = '__device_token__'

export const DEVICE_ID = '__device_id__'
export const SESSION_BROWSER_ID = '__session_browser_id__'

// Review apps are deployed per-MR under `<branch-slug>.intact.review.devebs.net`
// (see deployment/ci/review-apps.yml). The reCAPTCHA site key is not registered for
// that domain, so reCAPTCHA cannot be executed there — see `isRecaptchaBypassed`.
export const REVIEW_APP_DOMAIN = 'intact.review.devebs.net'

// Matches RECAPTCHA_WHITELISTED_TOKEN on the auth backend, which short-circuits
// verification when the submitted token equals this value.
export const RECAPTCHA_BYPASS_TOKEN = 'ebs-recaptcha-token'

export const DEFAULT_CURRENCY = 'MDL'
export const CAR_CURRENCY = 'EUR'

export const DEFAULT_PAGE_SIZE = 10

export const BLACK_COLOR = '#000000'
export const WHITE_COLOR = '#FFFFFF'

export const DEFAULT_COLORS = [
  '#FF0000',
  '#00FF00',
  '#0000FF',
  '#FFFF00',
  '#FF00FF',
  '#00FFFF',
  '#808080',
  '#800000',
  '#008000',
  '#000080'
]
